import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MoreVert from "@mui/icons-material/MoreVert";
import { CircularProgress } from "@mui/material";
import classNames from "classnames";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useTranslation } from "react-i18next";
import styles from "./DropDownMenu.module.scss";

const DropDownMenu = (props) => {
  const { t } = useTranslation();
  const {
    className: classNameProps,
    children,
    menuIcon,
    options,
    alignMenuRight = false,
  } = props;
  const [open, setOpen] = useState(false);

  const arrowRef = useRef(null);
  const menuRef = useRef(null);

  const iconClassName = useMemo(() => {
    if (classNameProps) {
      return [classNameProps, styles.menuIcon].join(" ");
    } else {
      return styles.menuIcon;
    }
  }, [classNameProps]);

  const handleGlobalClick = useCallback((e) => {
    if (
      arrowRef.current &&
      !arrowRef.current.contains(e.target) &&
      menuRef.current &&
      !menuRef.current.contains(e.target)
    ) {
      setOpen(false);
    }
  }, []);

  const handleToggleDropdown = useCallback(
    (e) => {
      e.preventDefault();
      //e.stopPropagation(); Propagation is required to close other menus when opening this one

      setOpen((open) => !open);
    },
    [setOpen]
  );

  useEffect(() => {
    window.addEventListener("click", handleGlobalClick);

    return () => {
      window.removeEventListener("click", handleGlobalClick);
    };
  }, [handleGlobalClick]);

  return (
    <div className={styles.container} ref={menuRef}>
      {/* We need to add the onclick for all children, if there are any. Clone is the right way*/}
      {children
        ? React.cloneElement(children, { onClick: handleToggleDropdown })
        : null}

      {
        //First check if menuIcon is ExpandMore, every other value is MoreVert
        (menuIcon === "ExpandMore" && (
          <KeyboardArrowDownIcon
            className={iconClassName}
            onClick={handleToggleDropdown}
            ref={arrowRef}
          />
        )) ||
          (menuIcon === "AddMore" && (
            <div className={styles.addButtonContainer}>
              <AddIcon
                fontSize="inherit"
                className={iconClassName}
                onClick={handleToggleDropdown}
                ref={arrowRef}
              />
            </div>
          )) || (
            <MoreVert
              className={iconClassName}
              onClick={handleToggleDropdown}
              ref={arrowRef}
            />
          )
      }
      <nav
        className={classNames(
          alignMenuRight ? styles.menuAlignRight : styles.menuAlignCenter,
          open ? styles.active : styles.inactive
        )}
      >
        <ul className={styles.optionList}>
          {options
            .filter((option) => !option.hideIf)
            .map((option) => (
              <li
                key={option.labelKey}
                className={classNames(
                  !option.disabled
                    ? styles.optionContainer
                    : styles.optionContainerDisabled,
                  option.isDivider ? styles.optionContainerDivider : null
                )}
                onClick={() => {
                  if (option.disabled) {
                    return;
                  }

                  option.onClick();
                  <CircularProgress size={16} />;
                  setOpen(false);
                }}
              >
                <div className={styles.optionContent}>
                  <span className={styles.optionContentText}>
                    {!option.isDivider && t(option.labelKey)}
                  </span>
                  {option.isChecked ? (
                    <CheckIcon className={styles.optionContentIconAfter} />
                  ) : (
                    <div />
                  )}
                </div>
              </li>
            ))}
        </ul>
      </nav>
    </div>
  );
};

export default DropDownMenu;
